// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f35657f4","977":"bbe99623"}[chunkId] + ".chunk.js";
};